/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_NoteInputs */

const en_directory_comparison_product_hunt_note = /** @type {(inputs: Directory_Comparison_Product_Hunt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Hunt is an independent product. This comparison describes positioning, not an affiliation or a claim about current Product Hunt features.`)
};

const zh_directory_comparison_product_hunt_note = /** @type {(inputs: Directory_Comparison_Product_Hunt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Hunt 是独立产品。此处比较的是产品定位，不代表双方存在关联，也不对其当前功能作保证。`)
};

/**
* | output |
* | --- |
* | "Product Hunt is an independent product. This comparison describes positioning, not an affiliation or a claim about current Product Hunt features." |
*
* @param {Directory_Comparison_Product_Hunt_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_note = /** @type {((inputs?: Directory_Comparison_Product_Hunt_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_note(inputs)
	return zh_directory_comparison_product_hunt_note(inputs)
});
export { directory_comparison_product_hunt_note as "directory.comparison.product_hunt.note" }